import { CategoryLabels } from './categories';
import { Nullable } from './utility';

type SummaryContentComponent = {
  id: string;
  type: string;
  sort: number;
};

export enum SummaryFormat {
  Boolean = 'boolean',
  Category = 'category',
  Check = 'check',
  Contact = 'contact',
  Currency = 'currency',
  Date = 'date',
  Email = 'email',
  Link = 'link',
  Number = 'number',
  Percent = 'percent',
  StateCheck = 'stateCheck',
  FullWidth = 'full-width',
  String = 'string',
}

export type SummaryContentComponentElement = {
  id: string;
  type: string;
  value: string;
  name: string;
  key: string;
  definition: string;
  format: SummaryFormat;
  document: string;
  context: string;
  newLineText?: boolean;
  options?: Record<string, string>;
  labels?: CategoryLabels;
};

export type SummaryControl = {
  id: string;
  type: string;
  permission: Nullable<string>;
  position: 'entity' | 'block';
  name: string;
  options: Record<string, unknown>;
};

export type SummaryContent = {
  id: string;
  type: string;
  blockId: string;
  title: string;
  identifier: string;
  view: string;
  context: string;
  components: SummaryContentComponent[];
  controls?: SummaryControl[];
  formLink?: string;
};

type SummaryActionResultSideEffects = 'deleted';

export type SummaryActionResult = {
  success: boolean;
  message: string;
  sideEffects: SummaryActionResultSideEffects[];
};

type SummaryTemplate = {
  id: string;
  type: string;
  key: string;
  contents?: SummaryContent[];
};

export type Summary = {
  id: string;
  type: string;
  definition: string;
  name: string;
  plural: string;
  template?: SummaryTemplate;
};
